<template>
  <div class="booking-confirmation">
    <div class="alert alert-success">
      <template>
        Your request has been submitted. We'll be in contact soon!
      </template>
    </div>
    <h3 class="wt-bold font-md mb-6 lh-tight mt-6">Thank you!</h3>
  </div>
</template>

<script>
import BaseModal from "../Base";

export default {
  extends: BaseModal,
  props: {
    data: {
      type: Object,
      required: false,
    },
  },
  methods: {},
};
</script>
